var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "qr-color-picker" },
    [
      _c("h6", [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "color-row border-gray-light rounded",
          class: { disabled: _vm.disabled },
          on: {
            click: function ($event) {
              !_vm.disabled && _setup.togglePicker()
            },
          },
        },
        [
          _c("span", {
            staticClass: "color-preview",
            style: { backgroundColor: _vm.color?.hex || "transparent" },
          }),
          _vm._v(
            "\n        " + _vm._s(_vm.color?.hex || "Transparent") + "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(_setup.ColorSelector, {
        ref: "pickerRef",
        attrs: { open: _setup.clickOutsideActive, color: _vm.color },
        on: {
          cancel: function ($event) {
            _setup.clickOutsideActive = false
          },
          "color-selected": _setup.onColorSelected,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }